import _ from 'lodash';
import React from 'react';

import {imageUrl} from '../../utilities/requests';


export default function Invoice(props) {
    return <div
        style={{
            width: '210mm',
            height: '148mm',
            margin: 0,
            position: 'relative',
            pageBreakAfter: 'always',
            direction: 'rtl',
            lineHeight: '1.9em',
        }}>
        <div
            style={{
                position: 'absolute',
                top: '60mm',
                left: '10mm',
                width: '85mm',
                height: '64mm',
            }}>
            <table
                style={{
                    float: 'right',
                    width: '90%',
                    borderCollapse: 'collapse',
                    textAlign: 'center',
                }}>
                <tbody>
                    <tr style={{backgroundColor: '#eaeaea'}}>
                        <td style={{width: '12mm', border: '.5mm solid black'}}>
                            {window.gettext('Index')}
                        </td>
                        <td style={{overflow: 'hidden', width: '50mm', border: '.5mm solid black'}}>
                            {window.gettext('Title')}
                        </td>
                        <td style={{width: '12mm', border: '.5mm solid black'}}>
                            {window.gettext('Count')}
                        </td>
                    </tr>
                    {_.map(props.items, (item, index) => <tr key={index}>
                        <td style={{width: '12mm', border: '.5mm solid black'}}>
                            {(index + 1).persian()}
                        </td>
                        <td style={{overflow: 'hidden', width: '50mm', border: '.5mm solid black'}}>
                            {item.caption}
                        </td>
                        <td style={{width: '12mm', border: '.5mm solid black'}}>
                            {item.count.persian()}
                        </td>
                    </tr>)}
                    <tr>
                        <td style={{width: '12mm', border: 'none'}}>
                        </td>
                        <td style={{width: '50mm', border: 'none', textAlign: 'left', paddingLeft: '2mm'}}>
                            {window.gettext('Total')}
                        </td>
                        <td style={{width: '12mm', border: '.5mm solid black'}}>
                            {_.reduce(
                                props.items,
                                (sum, item) => sum + item.count,
                                0,
                            ).persian()}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            style={{
                position: 'absolute',
                top: '10mm',
                left: '10mm',
                width: '85mm',
                fontSize: '1.2em',
            }}>
            <div style={{width: '100%', height: '100%', position: 'relative'}}>
                <span style={{fontSize: '1.5em', fontWeight: '700'}}>
                    {window.pgettext('invoice', 'From')}:&nbsp;
                </span>
                <span style={{fontSize: '1.2em'}}>
                    تهران
                </span>
                <br/>
                میدان فردوسی – نبش خیابان براتی – پلاک ۱۶
                <br/>
                واحد ۱۴
                <br/>
                کدپستی  ۱۱۳۱۸۵۶۶۴۴
                <br/>
                شماره تماس :&nbsp;
                <span style={{unicodeBidi: 'plaintext'}}>
                    ۰۲۱-۶۶۷۴۴۳۸۴-۵
                </span>
                <br/>
                <b>
                    مؤسسه آموزشی علامه حلی
                </b>
            </div>
        </div>
        <div
            style={{
                position: 'absolute',
                top: '84mm',
                right: '10mm',
                width: '98mm',
                fontSize: '1.2em',
            }}>
            <span style={{fontSize: '1.5em', fontWeight: '700'}}>
                {window.pgettext('invoice', 'To')}:&nbsp;
            </span>
            <span style={{fontSize: '1.2em'}}>
                {props.region_display} - {props.city_display}
            </span>
            <br/>
            {props.address ? props.address.persian() : '-'}
            <br/>
            {props.postal_code ? window.gettext('Postal Code') + ': ' + props.postal_code.persian() : null}
            {props.postal_code ? <br/> : null}
            {window.gettext('Contact Info')}: {props.phone ? `${props.phone.persian()} - ` : null}{props.cell_phone.persian()}
            <br/>
            <b>
                {props.firstname} {props.lastname}
            </b>
        </div>
        <div
            style={{
                position: 'absolute',
                top: '5mm',
                right: '10mm',
                width: '85mm',
                height: '84mm',
                color: '#D10305',
                textAlign: 'center',
            }}>
            <img
                src={imageUrl(window.images.logo, {
                    height: 170,
                    type: 'contain',
                })}
                onLoad={props.loaded}
            />
            <br/>
            <br/>
            <div
                style={{
                    fontSize: '2.5em',
                    fontWeight: '700',
                    border: '1mm solid #D10305',
                    borderRadius: '1mm',
                    padding: '.5cm',
                    textAlign: 'center',
                    display: 'inline-block',
                }}>
                {props.delivery_method !== null
                    ? {
                        0: window.gettext('Bespoke Post'),
                        1: window.gettext('Pishtaz Post'),
                        2: window.gettext('Transportation'),
                        3: window.gettext('Terminal'),
                    }[props.delivery_method]
                    : '-'
                }
            </div>
        </div>
    </div>;
}
